module.exports = __webpack_public_path__ + "img/BA.94239ee4.svg";